import ArrowDown from '../assets/img/dropdown.png';
import Mockup from '../assets/img/mockup.png';
import Circle from '../assets/img/circle3.png';
import Rectangle from '../assets/img/rect3.png';
import { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const HeroAb = () => {
    const [glowOne, setGlowOne] = useState({
        x: 0,
        y: 0
    });
    const [glowTwo, setGlowTwo] = useState({
        x: 0,
        y: 0
    });
    const [glowThree, setGlowThree] = useState({
        x: 0,
        y: 0
    });

    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, [])

    const handleHovering = (e) => {
        let new_y = (e.clientY * 4) / 150;
        let new_x = (e.clientX * 4) / 150;

        let new2_y = (e.clientY * 10) / 150;
        let new2_x = (e.clientX * 10) / 150;

        let new3_y = (e.clientY * 4) / 150;
        let new3_x = (e.clientX * 4) / 150;
        setGlowOne({x:new_x, y:new_y});
        setGlowTwo({x:new2_x, y:new2_y});
        setGlowThree({x:new3_x, y:new3_y});
    }

    return (
        <section className="Hero ab" id='About' onMouseMove={(e)=>handleHovering(e)}>
            <img src={ArrowDown} alt="scrolldown" className="scrolldown__arrow" />
            <div className='glow1' style={{transform: `translate3d(${glowOne.x}px, ${glowOne.y}px, 0px`}}></div>
            <div className='glow2' style={{transform: `translate3d(${glowTwo.x}px, ${glowTwo.y}px, 0px`}}></div>
            <div>
                <h1 data-aos="fade-right">
                    $LDT <br /> Tokenomics
                </h1>
                <p data-aos="zoom-in">The LadscatchNFT platform, which was developed to assist us in improving the live event experience, has a utility token called $LDT.</p>
            </div>
            <div className='mobile' data-aos="zoom-in">
                <img src={Mockup} alt="mockup" className='ticketnft' style={{transform: `translate3d(${glowThree.x}px, ${glowThree.y}px, 0px`}} />
                <img src={Circle} alt="circle" className='circle_mock' />
                <img src={Rectangle} alt="rectangle" className='rect_mock' />
            </div>
        </section>
    )
}

export default HeroAb;
